// src/router/AppRouter.js
import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';

// Componentes de autenticación
import LoginScreen from '../components/Auth/LoginScreen';
import Dashboard from '../components/Dashboard/Dashboard';


//reportes
import ReporteVentas from '../components/Reportes/Reporte';

// Módulos de la aplicación
import Ventas from '../components/Ventas/Ventas';
//import Inventario from '../modules/Inventario/Inventario';
import Clientes from '../components/Clientes/Clientes';
import Gastos from '../components/Gastos/Gastos';
import Mermas from '../components/Mermas/Mermas';
import SalidaInventario from '../components/SalidaInventario/SalidaInventario';
import EntradaInventario from '../components/EntradaInventario/EntradaInventario';
//import Reportes from '../modules/Reportes/Reportes';
//import Configuracion from '../modules/Configuracion/Configuracion';
//import Usuarios from '../modules/Usuarios/Usuarios';
// Componentes de Ventas - Nueva estructura organizada
// Mesa
import PedidoMesaDetalle from '../components/Ventas/pedidos/mesa/PedidoMesaDetalle';
import PedidosMesa from '../components/Ventas/pedidos/mesa/PedidosMesa';
// Componente compartido
import TomaPedidos from '../components/Ventas/TomaPedidos';
// Para llevar
import PedidosLlevar from '../components/Ventas/pedidos/llevar/PedidoLlevar';
import CreacionPedidoLlevar from '../components/Ventas/pedidos/llevar/CreacionPedidoLlevar';
// Delivery
import PedidosUber from '../components/Ventas/pedidos/delivery/PedidosUber';
import CreacionPedidoUber from '../components/Ventas/pedidos/delivery/CreacionPedidoUber';
import PedidosRappi from '../components/Ventas/pedidos/delivery/PedidosRappi';
import CreacionPedidoRappi from '../components/Ventas/pedidos/delivery/CreacionPedidoRappi';
import PedidosDelibot from '../components/Ventas/pedidos/delivery/PedidosDelibot';
import CreacionPedidoDelibot from '../components/Ventas/pedidos/delivery/CreacionPedidoDelibot';
// Domicilio
import PedidosDomicilio from '../components/Ventas/pedidos/domicilio/PedidosDomicilio';
import CreacionPedidoDomicilio from '../components/Ventas/pedidos/domicilio/CreacionPedidoDomicilio';
import ReportesGenerales from '../components/ReportesGenerales/ReportesGenerales';

import CorteCaja from '../components/CorteCaja/CorteCaja';
import GestionCompras from '../components/Compras/GestionCompras';
import FormaPago from '../components/Ventas/Pago/FormaPago';
import FormaPagoConDatos from '../components/Ventas/Pago/FormaPagoConDatos';
import ActualizarPrecios from '../components/Precios/ActualizarPrecios';
import MalasOrdenesGarantias from '../components/MalasOrdenesGarantias/MalasOrdenesGarantias';
import Promociones from '../components/Promociones/Promociones';
import Inventario from '../components/Inventario/Inventario';
import Configuracion from '../components/Configuracion/Configuracion';
import Platillos from '../components/Platillos/Platillos';
import Preparados from '../components/Preparados/Preparados';
import Usuarios from '../components/Usuarios/Usuarios';
import Meseros from '../components/Meseros/Meseros';
import CatalogoMesas from '../components/CatalogoMesas/CatalogoMesas';




//import MesaSelector from '../components/Ventas/MesaSelector';
//biometricos
import Biometrico from '../components/Biometrico/Biometrico';
import BiometricoTest from '../components/Biometrico/BiometricoTest';



// Contextos
import { AuthProvider, useAuth } from '../contexts/AuthContext';
import { ConfigProvider } from '../contexts/ConfigContext';

// Componente para rutas protegidas
const ProtectedRoute = ({ children, requiredPermission }) => {
  const { currentUser, hasPermission } = useAuth();

  // Verificar si el usuario está autenticado
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Verificar si tiene el permiso necesario (si se requiere)
  if (requiredPermission && !hasPermission(requiredPermission)) {
    // return <Navigate to="/dashboard" />;
  }

  return children;
};

function AppRouter() {
  return (
    <HashRouter>
      <ConfigProvider>
        <AuthProvider>
          <Routes>
            {/* Ruta pública */}
            <Route path="/login" element={<LoginScreen />} />

            {/* Ruta para el dashboard */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/*} Rutas para módulos específicos con verificación de permisos */}
            <Route
              path="/ventas"
              element={
                <ProtectedRoute requiredPermission="cuentas">
                  <Ventas />
                </ProtectedRoute>
              }
            />

            <Route
              path="/corte-caja"
              element={
                <ProtectedRoute requiredPermission="cuentas">
                  <CorteCaja />
                </ProtectedRoute>
              }
            />

            <Route
              path="/reportes-generales"
              element={
                <ProtectedRoute requiredPermission="reportes">
                  <ReportesGenerales />
                </ProtectedRoute>
              }
            />











            <Route path="/mesa-detalle/:idMesa" element={
              <ProtectedRoute requiredPermission="cuentas">
                <PedidoMesaDetalle />
              </ProtectedRoute>
            } />
            <Route path="/llevar" element={
              <ProtectedRoute requiredPermission="cuentas">
                <PedidosLlevar />
              </ProtectedRoute>
            } />

            <Route path="/domicilio" element={
              <ProtectedRoute requiredPermission="cuentas">
                <PedidosDomicilio />
              </ProtectedRoute>
            } />

            <Route path="/uber" element={
              <ProtectedRoute requiredPermission="cuentas">
                <PedidosUber />
              </ProtectedRoute>
            } />

            <Route path="/rappi" element={
              <ProtectedRoute requiredPermission="cuentas">
                <PedidosRappi />
              </ProtectedRoute>
            } />

            <Route path="/delibot" element={
              <ProtectedRoute requiredPermission="cuentas">
                <PedidosDelibot />
              </ProtectedRoute>
            } />


            {/* Rutas de creación de pedidos */}
            <Route path="/llevar-nuevo" element={
              <ProtectedRoute requiredPermission="cuentas">
                <CreacionPedidoLlevar />
              </ProtectedRoute>
            } />

            <Route path="/domicilio-nuevo" element={
              <ProtectedRoute requiredPermission="cuentas">
                <CreacionPedidoDomicilio />
              </ProtectedRoute>
            } />

            <Route path="/uber-nuevo" element={
              <ProtectedRoute requiredPermission="cuentas">
                <CreacionPedidoUber />
              </ProtectedRoute>
            } />

            <Route path="/rappi-nuevo" element={
              <ProtectedRoute requiredPermission="cuentas">
                <CreacionPedidoRappi />
              </ProtectedRoute>
            } />

            <Route path="/delibot-nuevo" element={
              <ProtectedRoute requiredPermission="cuentas">
                <CreacionPedidoDelibot />
              </ProtectedRoute>
            } />

            {/* Las rutas de nueva-compra y control-compras ahora son modales en el Dashboard */}

            {/* Mantener la ruta original para compatibilidad */}
            <Route path="/compras" element={
              <ProtectedRoute requiredPermission="cuentas">
                <GestionCompras />
              </ProtectedRoute>
            } />
            <Route path="/actualizar-precios" element={
              <ProtectedRoute requiredPermission="cuentas">
                <ActualizarPrecios />
              </ProtectedRoute>

            } />
            <Route path="/malas-ordenes-garantias" element={
              <ProtectedRoute requiredPermission="cuentas">
                <MalasOrdenesGarantias />
              </ProtectedRoute>

            } />
            <Route path="/promociones" element={
              <ProtectedRoute requiredPermission="cuentas">
                <Promociones />
              </ProtectedRoute>

            } />
            <Route path="/inventario" element={
              <ProtectedRoute requiredPermission="inventario">
                <Inventario />
              </ProtectedRoute>

            } />

            <Route path="/pagar-pedido/:idPedido" element={
              <ProtectedRoute requiredPermission="compra">
                <FormaPagoConDatos />
              </ProtectedRoute>

            } />






















            {/* NUEVA RUTA: Módulo de Biométrico */}
            <Route
              path="/biometrico"
              element={
                <ProtectedRoute requiredPermission="cuentas">
                  <BiometricoTest />
                </ProtectedRoute>
              }
            />




            <Route
              path="/reporte"
              element={
                <ProtectedRoute requiredPermission="cuentas">
                  <ReporteVentas />
                </ProtectedRoute>
              }
            />
            <Route
              path="/platillos"
              element={
                <ProtectedRoute requiredPermission="cuentas">
                  <Platillos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/preparados"
              element={
                <ProtectedRoute requiredPermission="cuentas">
                  <Preparados />
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientes"
              element={
                <ProtectedRoute>
                  <Clientes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gastos"
              element={
                <ProtectedRoute>
                  <Gastos />
                </ProtectedRoute>
              }
            />

            <Route
              path="/mermas"
              element={
                <ProtectedRoute requiredPermission="merma">
                  <Mermas />
                </ProtectedRoute>
              }
            />

            <Route
              path="/salida-inventario"
              element={
                <ProtectedRoute requiredPermission="salida_inventario">
                  <SalidaInventario />
                </ProtectedRoute>
              }
            />

            <Route
              path="/entrada-inventario"
              element={
                <ProtectedRoute requiredPermission="entrada_inventario">
                  <EntradaInventario />
                </ProtectedRoute>
              }
            />

            <Route
              path="/configuracion"
              element={
                <ProtectedRoute requiredPermission="cuentas">
                  <Configuracion />
                </ProtectedRoute>
              }
            />

            <Route
              path="/mesas"
              element={
                <ProtectedRoute requiredPermission="catalogoMesas">
                  <CatalogoMesas />
                </ProtectedRoute>
              }
            />

            <Route
              path="/meseros"
              element={
                <ProtectedRoute requiredPermission="meseros">
                  <Meseros />
                </ProtectedRoute>
              }
            />

            <Route
              path="/usuarios"
              element={
                <ProtectedRoute requiredPermission="catalogoUsuarios">
                  <Usuarios />
                </ProtectedRoute>
              }
            />

            <Route
              path="/perfiles"
              element={
                <ProtectedRoute requiredPermission="catalogoPerfiles">
                  <Usuarios />
                </ProtectedRoute>
              }
            />

             {/*<Route
              path="/reportes/*"
              element={
                <ProtectedRoute requiredPermission="reportes">
                  <Reportes />
                </ProtectedRoute>
              }
            />

            <Route
              path="/configuracion/*"
              element={
                <ProtectedRoute requiredPermission="configuracion">
                  <Configuracion />
                </ProtectedRoute>
              }
            />

            <Route
              path="/usuarios/*"
              element={
                <ProtectedRoute requiredPermission="catalogoUsuarios">
                  <Usuarios />
                </ProtectedRoute>
              }
            />*/}

            {/* Ruta por defecto redirecciona al login */}
            <Route
              path="*"
              element={
                <Navigate to="/login" replace />
              }
            />
          </Routes>
        </AuthProvider>
      </ConfigProvider>
    </HashRouter>
  );
}

export default AppRouter;